import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createBlock as _createBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withModifiers as _withModifiers, withCtx as _withCtx, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ba76164"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = {
  key: 0,
  class: "main__wrapper"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "main__title" }, "Choose currency bellow:", -1))
const _hoisted_4 = { class: "exchange" }
const _hoisted_5 = {
  key: 0,
  class: "exchange__alert"
}
const _hoisted_6 = { class: "exchange__data" }
const _hoisted_7 = { class: "exchange__rates" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "main__title" }, "Currency rates", -1))
const _hoisted_9 = { class: "rates" }
const _hoisted_10 = { class: "rates__info" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rates__info-title" }, " Choose interested currency to have an rates information: ", -1))
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "rates__cards" }
const _hoisted_14 = { class: "rates__controls" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { id: "rates" }
const _hoisted_18 = ["value"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-search",
  type: "submit"
}, " + Add rate card ", -1))
const _hoisted_20 = {
  key: 1,
  class: "server_info"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" If you see loader to long - "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" coinapi.io REST API dont give an answer "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" with needed data for App working ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_exchangeField = _resolveComponent("exchangeField")!
  const _component_rateCard = _resolveComponent("rateCard")!
  const _component_cardModal = _resolveComponent("cardModal")!
  const _component_loader = _resolveComponent("loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("main", _hoisted_1, [
      (_ctx.rates)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              (_ctx.isBigValue)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, " You can exchange maximum " + _toDisplayString(_ctx.maxValue) + " " + _toDisplayString(_ctx.originalCurrency), 1))
                : _createCommentVNode("", true),
              _createVNode(_component_exchangeField, {
                currencyList: _ctx.currencyList,
                currencyInput: _ctx.originalCurrencyInput,
                "onUpdate:currencyInput": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.originalCurrencyInput) = $event)),
                currency: _ctx.originalCurrency,
                "onUpdate:currency": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.originalCurrency) = $event))
              }, null, 8, ["currencyList", "currencyInput", "currency"]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                  class: "exchange__switch-btn",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchCurrency()))
                }, " Switch "),
                _createElementVNode("div", _hoisted_7, " 1 " + _toDisplayString(_ctx.data.asset_id_base) + " = " + _toDisplayString(_ctx.currentRate) + " " + _toDisplayString(_ctx.data.asset_id_quote), 1)
              ]),
              _createVNode(_component_exchangeField, {
                currencyList: _ctx.currencyList,
                currencyInput: _ctx.desiredCurrencyInput,
                "onUpdate:currencyInput": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.desiredCurrencyInput) = $event)),
                currency: _ctx.desiredCurrency,
                "onUpdate:currency": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.desiredCurrency) = $event)),
                disabledInput: true
              }, null, 8, ["currencyList", "currencyInput", "currency"])
            ]),
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _withDirectives(_createElementVNode("select", {
                  class: "rates__info-select",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.interestedCurrency) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.interestedCurrencyList, (currency, idx) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: idx,
                      value: currency
                    }, _toDisplayString(currency), 9, _hoisted_12))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.interestedCurrency]
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.choosenRatesData, (rate, i) => {
                  return (_openBlock(), _createBlock(_component_rateCard, {
                    key: i,
                    name: rate.asset_id_quote,
                    rate: rate.rate
                  }, null, 8, ["name", "rate"]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("button", {
                  class: "btn",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openModal = true))
                }, " + Add more cards "),
                _createElementVNode("button", {
                  class: "btn",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.refreshData && _ctx.refreshData(...args))),
                  disabled: _ctx.refreshDisabled
                }, [
                  _createTextVNode(" Refresh data "),
                  (_ctx.refreshDisabled)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, "(" + _toDisplayString(_ctx.disabledDuration) + ")", 1))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_15)
              ])
            ]),
            (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
              _createVNode(_component_cardModal, {
                openModal: _ctx.openModal,
                title: "Add new card",
                onClose: _cache[10] || (_cache[10] = (val) => (_ctx.openModal = val))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("form", {
                    action: "#",
                    onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.cardFormHandler && _ctx.cardFormHandler(...args)), ["prevent"]))
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      list: "rates",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.addCardName) = $event)),
                      class: "search-input"
                    }, null, 512), [
                      [_vModelText, _ctx.addCardName]
                    ]),
                    _createElementVNode("datalist", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rates, (rate, i) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: i,
                          value: rate.asset_id_quote
                        }, null, 8, _hoisted_18))
                      }), 128))
                    ]),
                    _hoisted_19
                  ], 32)
                ]),
                _: 1
              }, 8, ["openModal"])
            ]))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createVNode(_component_loader),
            _hoisted_21
          ]))
    ])
  ], 64))
}